import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';

export default function Footer() {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        px: { xs: 3, md: 8 },
        pt: 4,
        pb: 'calc(32px + env(safe-area-inset-bottom))',
        borderTop: '1px solid',
        borderColor: 'divider',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 2,
        bgcolor: 'background.default',
      }}
    >
      <Box
        component="img"
        src={isDark ? '/resources/logo/dark.svg' : '/resources/logo/light.svg'}
        alt="Turf"
        onClick={() => navigate('/')}
        sx={{ height: 22, cursor: 'pointer' }}
      />
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0, flexWrap: 'wrap' }}>
        {[{ label: 'Privacy', path: '/privacy' }, { label: 'Terms', path: '/terms' }].map(({ label, path }, i) => (
          <React.Fragment key={label}>
            {i > 0 && (
              <Typography variant="caption" sx={{ color: 'text.disabled', mx: 1.5 }}>·</Typography>
            )}
            <Typography
              variant="caption"
              onClick={() => navigate(path)}
              sx={{ color: 'text.disabled', cursor: 'pointer', '&:hover': { color: 'text.secondary' }, transition: 'color 0.15s' }}
            >
              {label}
            </Typography>
          </React.Fragment>
        ))}
        <Typography variant="caption" sx={{ color: 'text.disabled', mx: 1.5 }}>·</Typography>
        <Typography variant="caption" sx={{ color: 'text.disabled' }}>
          © 2026 Stewart Thomson. All rights reserved.
        </Typography>
      </Box>
    </Box>
  );
}
